import React, { useCallback } from 'react'
import { router } from 'src/router'
import { useAppSelector } from 'src/hooks/redux/useAppSelector'
import { RouterProvider } from 'react-router-dom'
import { RootState } from 'src/store/store'
import { useAppDispatch } from 'src/hooks/redux/useAppDispatch'
import { GoogleReCaptcha } from 'react-google-recaptcha-v3'

import SessionStorageUtils from 'src/utils/SessionStorage.utils'
import { setRecaptchaTokenUpdateFlag } from 'src/store/Reducer/common/commonSlice'
import { createGlobalStyle } from 'styled-components'
import { COLOR } from 'src/constants/colors'

const App = (): JSX.Element => {
  const { updateStorageData } = SessionStorageUtils()
  const dispatch = useAppDispatch()
  const { RecaptchaRefresh, RecaptchaTokenUpdateFlag } = useAppSelector(
    (state: RootState) => state.common,
  )
  const { Status } = useAppSelector((state: RootState) => state.LoginPage)
  const handleVerify = useCallback((value: string) => {
    updateStorageData('token', value)
    //새로고침시 리캡챠 재발급 후 사용
    dispatch(setRecaptchaTokenUpdateFlag(!RecaptchaTokenUpdateFlag))
    // console.log('token update complete')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <GlobalStyle
        active={`${
          window.location.pathname === '/' &&
          Status !== 'isNotApp' &&
          Status !== 'pinMoreThanFiveTimes'
        }`}
      />
      <GoogleReCaptcha onVerify={handleVerify} refreshReCaptcha={RecaptchaRefresh} />
      <RouterProvider router={router} />
    </>
  )
}

export default App

const GlobalStyle = createGlobalStyle<{ active?: string }>`
  body {
      &::-webkit-scrollbar {
          width: 14px; /* 스크롤바의 너비 */
      }

      &::-webkit-scrollbar-thumb {
          height: 30%; /* 스크롤바의 길이 */
          background: ${COLOR.black30}; /* 스크롤바의 색상 */
          border-radius: 12px;
      }

      &::-webkit-scrollbar-track {
          background: ${COLOR.black10}; /*스크롤바 뒷 배경 색상*/
          border-radius: 12px;
      }
    .grecaptcha-badge {
       visibility: ${(props) => (props.active === 'true' ? 'unset' : 'hidden')}
    }
  }
`
